import { observable, toJS } from "mobx";
import DataStore from "../../../stores/DataStore";
import ServicosService from "../services/ServicosService";
import { E_CG_REF_CODES, E_ORIGEM_CARGA, E_SENTIDO_OPERACAO, E_TIPO_CLIENTE, E_TIPO_TELA } from "./Enum";

export default class SimulacaoServicosFilterStore extends DataStore {

    @observable tipoCliente;
    @observable ehNacional = false;
    @observable sentidoOperacao;
    @observable tipoTransbordo;
    @observable modalidade;
    @observable origemCarga;

    tiposCliente = this.defaultObj([]);
    sentidosOperacao = this.defaultObj([]);
    tiposTransbordo = this.defaultObj([]);
    modalidades = this.defaultObj([]);
    origensCarga = this.defaultObj([]);

    queryObject;

    get iniciarSimulacaoEnabled() {
        const enable = (this.tipoCliente && this.sentidoOperacao && this.modalidade && this.origemCarga) 

        return enable != null ? enable : false;
    }

    get filters() {
        return ({
            tipoCliente: this.tipoCliente, 
            tipoTransbordo: this.tipoTransbordo, 
            sentidoOperacao: this.sentidoOperacao, 
            modalidade: this.modalidade,
            origemCarga: this.origemCarga,
            ehNacional: this.ehNacional,
        })
    }

    get tiposClienteOptions() {
        if ([E_TIPO_TELA.Transbordo, E_TIPO_TELA.Remocoes].includes(this.modalidade))
            return toJS(this.tiposCliente.value).filter(({ value }) => {
                return value != E_TIPO_CLIENTE.Carga;
            });

        return toJS(this.tiposCliente.value)
    }
    
    get tiposTransbordoOptions() {
        return toJS(this.tiposTransbordo.value)
    }

    get sentidosOperacaoOptions() {
        return toJS(this.sentidosOperacao.value).filter(({ value }) => {
            if ([E_TIPO_TELA.Remocoes].includes(this.modalidade)) 
                return ![E_SENTIDO_OPERACAO.Embarque, E_SENTIDO_OPERACAO.Desembarque, E_SENTIDO_OPERACAO.Embarque_Desembarque].includes(value);
            else if ([E_TIPO_TELA.Transbordo].includes(this.modalidade)) 
                return [E_SENTIDO_OPERACAO.Embarque_Desembarque].includes(value);
            else
            return ![E_SENTIDO_OPERACAO.RemocaoBordo, E_SENTIDO_OPERACAO.RemocaoTerra, E_SENTIDO_OPERACAO.Embarque_Desembarque].includes(value);
        });
    }

    get modalidadesOptions() {
        if (this.tipoCliente === E_TIPO_CLIENTE.Carga)
            return toJS(this.modalidades.value).filter(({ value }) => {
                return ![E_TIPO_TELA.Transbordo, E_TIPO_TELA.Remocoes].includes(value);
            });

        return toJS(this.modalidades.value);
    }

    get origensCargaOptions() {     
        return toJS(this.origensCarga.value).filter(({ value }) => {
            if ([E_TIPO_TELA.Transbordo].includes(this.modalidade)) 
                return [E_ORIGEM_CARGA.Importada_Nacional].includes(value);
            else
                return ![E_ORIGEM_CARGA.Importada_Nacional].includes(value);
        });
    }

    get showEhNacional() {
        return [E_TIPO_CLIENTE.Armador].includes(this.tipoCliente)
    }

    get showTransbordoOption() {
        return [E_TIPO_TELA.Transbordo].includes(this.modalidade);
    }
    
    get disableSentidoOperacao() {
        return !this.modalidade || [E_TIPO_TELA.Importacao, E_TIPO_TELA.Exportacao, E_TIPO_TELA.Transbordo].includes(this.modalidade);
    }

    get disableOrigemDaCarga() {
        return ![E_TIPO_TELA.Remocoes].includes(this.modalidade);
    }

    clearFilters() {
        this.setTipoCliente(null);
        this.setModalidade(null);
    }

    setQuery(params) {
        this.queryObject = params;
    }

    //Filter Options
    async fetchFilterOptions() {
        console.log(this.queryObject)
        try {
            await Promise.all([
                this.fetchAndSetData(this.tiposCliente, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.TipoCliente),
                this.fetchAndSetData(this.sentidosOperacao, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.SentidoOperacao),
                this.fetchAndSetData(this.modalidades, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.Modalidade),
                this.fetchAndSetData(this.origensCarga, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.OrigemCarga),
                this.fetchAndSetData(this.tiposTransbordo, ServicosService.listarOpcoesServicosPorTipo, E_CG_REF_CODES.TipoTransbordo),
            ]).then(() => {
                if (Object.hasOwn(this.queryObject, 'tipoCliente')) 
                    this.setTipoCliente(this.queryObject.tipoCliente);
                if (Object.hasOwn(this.queryObject, 'modalidade')) 
                    this.setModalidade(this.queryObject.modalidade);
                if (Object.hasOwn(this.queryObject, 'sentidoOperacao') && ![E_TIPO_TELA.Exportacao, E_TIPO_TELA.Importacao].includes(this.modalidade)) 
                    this.setSentidoOperacao(this.queryObject.sentidoOperacao);
                if (Object.hasOwn(this.queryObject, 'origemCarga') && ![E_TIPO_TELA.Cabotagem, E_TIPO_TELA.Exportacao, E_TIPO_TELA.Importacao].includes(this.modalidade)) 
                    this.setOrigemCarga(this.queryObject.origemCarga);
                if (Object.hasOwn(this.queryObject, 'ehNacional')) 
                    this.setEhNacional(this.queryObject.ehNacional);
                if (Object.hasOwn(this.queryObject, 'tipoTransbordo')) 
                    this.setTipoTransbordo(this.queryObject.tipoTransbordo);
            });
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * Setter para this.tipoCliente
     */
    setTipoCliente = (tipoCliente) => {
        this.tipoCliente = tipoCliente;

        this.setEhNacional(this.tipoCliente == E_TIPO_CLIENTE.Carga);
    }

    /**
     * Setter para this.tipoTransbordo
     */
    setTipoTransbordo = (tipoTransbordo) => {
        this.tipoTransbordo = tipoTransbordo;
    }

    /**
     * Setter para this.ehNacional
     */
    setEhNacional = (ehNacional) => {
        this.ehNacional = ehNacional;
    }

    /**
     * Setter para this.sentidoOperacao
     */
    setSentidoOperacao = (sentidoOperacao) => {
        this.sentidoOperacao = sentidoOperacao;
    }

    /**
     * Setter para this.modalidade
     */
    setModalidade = (modalidade) => {
        this.modalidade = modalidade;

        this.setSentidoOperacao(null);
        this.setOrigemCarga(null);
        this.setTipoTransbordo(null);

        if([E_TIPO_TELA.Cabotagem, E_TIPO_TELA.Exportacao, E_TIPO_TELA.Importacao, E_TIPO_TELA.Transbordo].includes(this.modalidade)) {
            let sentidoOperacao = '';
            if(this.modalidade === E_TIPO_TELA.Exportacao) sentidoOperacao = E_SENTIDO_OPERACAO.Embarque;
            if(this.modalidade === E_TIPO_TELA.Importacao) sentidoOperacao = E_SENTIDO_OPERACAO.Desembarque;
            if(this.modalidade === E_TIPO_TELA.Transbordo) sentidoOperacao = E_SENTIDO_OPERACAO.Embarque_Desembarque;

            const optSentidoOperacao = this.sentidosOperacao.value.find(o => o.value == sentidoOperacao);
            this.setSentidoOperacao(optSentidoOperacao ? optSentidoOperacao.value : null);
            
            let origenDaCarga = '';
            if(this.modalidade === E_TIPO_TELA.Exportacao) origenDaCarga = E_ORIGEM_CARGA.Nacional;
            if(this.modalidade === E_TIPO_TELA.Cabotagem) origenDaCarga = E_ORIGEM_CARGA.Nacional;
            if(this.modalidade === E_TIPO_TELA.Importacao) origenDaCarga = E_ORIGEM_CARGA.Importada;
            if(this.modalidade === E_TIPO_TELA.Transbordo) origenDaCarga = E_ORIGEM_CARGA.Importada_Nacional;     

            const optOrigemCarga = this.origensCarga.value.find(o => o.value == origenDaCarga);

            this.setOrigemCarga(optOrigemCarga ? optOrigemCarga.value : null);
        }
    }

    /**
     * Setter para this.origemCarga
     */
    setOrigemCarga = (origemCarga) => {
        this.origemCarga = origemCarga;
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/stores/SimulacaoServicosFilterStore.js